"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeBlurhash = void 0;
const digit = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz#$%*+,-.:;=?@[]^_{|}~';
const decode83 = (str, start, end) => {
    let i = start;
    let value = 0;
    while (i < end) {
        value *= 83;
        value += digit.indexOf(str[i++]);
    }
    return value;
};
const { PI, trunc } = Math;
const PI2 = PI * 2;
const d = 3294.6;
const e = 269.025;
const sRGBToLinear = (value) => value > 10.31475 ? Math.pow((value / e + 0.052132), 2.4) : value / d;
const linearTosRGB = (v) => trunc(v > 0.00001227 ? e * Math.pow(v, 0.416666) - 13.025 : v * d + 1);
const signSqr = (x) => (x < 0 ? -1 : 1) * x * x;
const fastCos = (x) => {
    let n = x + PI / 2;
    while (n > PI) {
        n -= PI2;
    }
    const cos = 1.27323954 * n - 0.405284735 * signSqr(n);
    return 0.225 * (signSqr(cos) - cos) + cos;
};
function decodeBlurhash(blurhash, width, height, punch = 0) {
    const sizeFlag = decode83(blurhash, 0, 1);
    const numX = (sizeFlag % 9) + 1;
    const numY = trunc(sizeFlag / 9) + 1;
    const size = numX * numY;
    const maximumValue = ((decode83(blurhash, 1, 2) + 1) / 13446) * (punch | 1);
    const colors = new Float64Array(size * 3);
    let value = decode83(blurhash, 2, 6);
    colors[0] = sRGBToLinear(value >> 16);
    colors[1] = sRGBToLinear((value >> 8) & 255);
    colors[2] = sRGBToLinear(value & 255);
    let i = 0;
    let j = 0;
    let x = 0;
    let y = 0;
    let r = 0;
    let g = 0;
    let b = 0;
    let basis = 0;
    let basisY = 0;
    let colorIndex = 0;
    let pixelIndex = 0;
    let yh = 0;
    let xw = 0;
    for (i = 1; i < size; i++) {
        value = decode83(blurhash, 4 + i * 2, 6 + i * 2);
        colors[i * 3] = signSqr(trunc(value / (19 * 19)) - 9) * maximumValue;
        colors[i * 3 + 1] = signSqr((trunc(value / 19) % 19) - 9) * maximumValue;
        colors[i * 3 + 2] = signSqr((value % 19) - 9) * maximumValue;
    }
    const bytesPerRow = width * 4;
    const pixels = new Uint8ClampedArray(bytesPerRow * height);
    for (y = 0; y < height; y++) {
        yh = (PI * y) / height;
        for (x = 0; x < width; x++) {
            r = 0;
            g = 0;
            b = 0;
            xw = (PI * x) / width;
            for (j = 0; j < numY; j++) {
                basisY = fastCos(yh * j);
                for (i = 0; i < numX; i++) {
                    basis = fastCos(xw * i) * basisY;
                    colorIndex = (i + j * numX) * 3;
                    r += colors[colorIndex] * basis;
                    g += colors[colorIndex + 1] * basis;
                    b += colors[colorIndex + 2] * basis;
                }
            }
            pixelIndex = 4 * x + y * bytesPerRow;
            pixels[pixelIndex] = linearTosRGB(r);
            pixels[pixelIndex + 1] = linearTosRGB(g);
            pixels[pixelIndex + 2] = linearTosRGB(b);
            pixels[pixelIndex + 3] = 255;
        }
    }
    return pixels;
}
exports.decodeBlurhash = decodeBlurhash;
